import React, { createContext, useContext, useEffect, useState } from 'react';
import { ThemeProvider, useTheme as useNextTheme } from 'next-themes';

const ColorModeContext = createContext(undefined);

export function ColorModeProvider({ children, ...props }) {
  return (
    <ThemeProvider
      attribute="class"
      disableTransitionOnChange
      defaultTheme="light"
      enableSystem={false}
      storageKey="aevdir.theme"
      {...props}
    >
      <ColorModeContextBridge>{children}</ColorModeContextBridge>
    </ThemeProvider>
  );
}

function ColorModeContextBridge({ children }) {
  const { resolvedTheme, setTheme, forcedTheme } = useNextTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const colorMode = mounted ? resolvedTheme || 'light' : 'light';

  const value = {
    colorMode,
    forcedTheme,
    setColorMode: setTheme,
    toggleColorMode: () => setTheme(colorMode === 'dark' ? 'light' : 'dark'),
  };

  return <ColorModeContext.Provider value={value}>{children}</ColorModeContext.Provider>;
}

export function useColorMode() {
  const context = useContext(ColorModeContext);
  if (!context) {
    throw new Error('useColorMode must be used within ColorModeProvider');
  }
  return context;
}

export function ColorModeIcon() {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return isDark ? (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none">
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none">
      <path
        d="M21 14.5A8.5 8.5 0 0 1 9.5 3 7 7 0 1 0 21 14.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
